import { useAppSelector } from 'app/state'

import HeaderBase from 'features/common/ui/AppTemplate/Header/HeaderBase'
import BuilderHeaderActions from './BuilderHeaderActions/BuilderHeaderActions'
import { getCurrentMap } from 'features/maps/state/mapsSlice'
import { Tooltip } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { useBrandingLogo } from 'features/branding/hooks/brandingHooks'
import useMobileBuilder from '../../useMobileBuilder'
import { CollaborationTitleChip } from './BuilderMapTitle/CollaborationTitleChip'
import { FeatureFlag, useFeatureFlag } from 'app/ui/useFeatureFlag'
import useMapSharingInfo from 'features/maps/state/useMapSharingInfo'
import MapSavingIndicator from './MapSavingIndicator/MapSavingIndicator'
import MapTitleEditor from './BuilderMapTitle/MapTitleEditor'
import { ReactElement, useMemo } from 'react'

function BuilderHeader({
  viewOnly,
  dontShowTitle,
  brandText: customBrandText
}: {
  viewOnly?: boolean
  dontShowTitle?: boolean
  brandText?: ReactElement
}) {
  const currentMap = useAppSelector(getCurrentMap)
  const logo = useBrandingLogo()
  const isMobile = useMobileBuilder()
  const collaborativeMapsEnabled = useFeatureFlag(FeatureFlag.CollaborativeMaps)
  const { isEditable: isMapEditable } = useMapSharingInfo(currentMap)
  const isEditable = !viewOnly && isMapEditable
  const showMapTitleEditor = isEditable && !viewOnly

  const titleInBrandText = viewOnly && !dontShowTitle

  const brandText = useMemo(() => {
    return customBrandText ? (
      customBrandText
    ) : titleInBrandText ? (
      <span data-testid="map-title">{currentMap?.title ?? ''}</span>
    ) : (
      <FormattedMessage id={isMobile ? 'builder.navBar.titleMobile' : 'builder.navBar.title'} />
    )
  }, [titleInBrandText, customBrandText, currentMap, isMobile])

  return (
    <HeaderBase
      brandLogo={
        <Tooltip arrow title={<FormattedMessage id="builder.navBar.titleTooltip" />}>
          <a href="/">
            <img alt="carto-logo-dot" src={logo} />
          </a>
        </Tooltip>
      }
      brandText={brandText}
      secondaryText={showMapTitleEditor && <MapTitleEditor />}
      actions={<BuilderHeaderActions viewOnly={viewOnly} currentMap={currentMap} />}
      showWorkspaceButton
      headerInfo={
        <>
          {collaborativeMapsEnabled && <CollaborationTitleChip />}
          {isEditable && <MapSavingIndicator />}
        </>
      }
    />
  )
}

export default BuilderHeader
